<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New EPAY Logo {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View EPAY Logo - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit EPAY Logo - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{epay_logo.created_by}} | {{epay_logo.created_at | dateFilter}} 
                <br>
                <b><label>Updated By:</label></b>
                {{epay_logo.updated_by}} | {{epay_logo.updated_at | dateFilter}} 
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <div class="row" v-if="customFormMode == 1" v-show="showDetails">
                 <!-- Normal -->
                <div class="col-md-4">
                    <base-input alternative="" label="Upload Photo">
                        <a-upload
                        :action="uploadEpayLogoImage"
                        listType="picture-card"
                        :fileList="fileList"
                        @preview="handlePreview"
                        @change="handleChange"
                        :headers="authHeaders"
                        >
                            <div v-if="fileList.length < 1 && imageLoaded == true"> +
                                <div class="ant-upload-text">Upload</div>
                            </div>
                        </a-upload>
                        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                            <img alt="example" style="width: 100%" :src="previewImage" />
                        </a-modal>
                    </base-input>
                </div>

                <div class="col-md-8">
                    <base-input alternative="" label="Code" placeholder="" v-model="epay_logo.code" input-classes="form-control"/>
                    <base-input alternative="" label="Name" placeholder="" v-model="epay_logo.name" input-classes="form-control" required />
                    <base-input alternative="" label="Remark">
                        <textarea rows="4" class="form-control" v-model="epay_logo.remark" />
                    </base-input>
                </div>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="epay_logo" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="epay_logo.code" input-classes="form-control"/>
                        <base-input alternative="" label="Name" placeholder="" v-model="epay_logo.name" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="epay_logo.remark" />
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="epay_logo" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>


            <div v-if="this.$attrs.viewMode != true">
                <div  v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-epay_logo: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-epay_logo: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    import moment from 'moment'
    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType', 'publicUrl']),
        },
        mounted: async function () {

            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Epay Logo?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId +'?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
             const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
             if(accSystemModule != null){
                 if(accSystemModule.form_mode != undefined){
                     this.customFormMode = accSystemModule.form_mode
                 }
                 if(accSystemModule.customized_forms != undefined){
                     this.customForm = accSystemModule.customized_forms
                 }
             }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0){
                var epay_logo_data = await HTTPRequest.getRequest(component_x.endPoint + 'epay_logos/' + component_x.profileId, null)
                if(epay_logo_data == undefined){
                    component_x.$router.go()
                } else {
                    if(epay_logo_data["error"] == undefined){
                        component_x.epay_logo = epay_logo_data
                        component_x.inputName = epay_logo_data["name"]
                        component_x.inputCode = epay_logo_data["code"]
                        component_x.inputRemark = epay_logo_data["remark"]

                        if (epay_logo_data["filename"] != null) {
                            this.fileList = [{
                                uid: epay_logo_data['id'],
                                name: epay_logo_data["filename"],
                                status: 'done',
                                url: this.publicUrl + 'epay_logos_images/' + epay_logo_data["filename"]
                            }]
                        } else {
                            this.fileList = []
                        }

                        this.imageLoaded = true

                    } else {
                        this.errors = epay_logo_data["error"].split(",");
                    } 
                }
            } 

            this.dynamicFormKey++;
        },
        data: function () {
            return {
                inputName: '',
                inputCode: '',
                inputRemark: '',
                errors: [],
                showDetails: true,

                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                epay_logo: {},
                formErrors: [],

                // UPLOADER
                previewVisible: false,
                previewImage: '',
                fileList: [],
                imageLoaded: true,
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File" },

            }
        },
        filters: {
            dateFilter: function (timestamp) {
                return moment(timestamp).format('L LTS')
            }
        },
        methods: {
            // Upload
            uploadEpayLogoImage() {
                return this.endPoint + 'epay_logos/upload_image'
            },
            handleCancel () {
                this.previewVisible = false
            },
            handlePreview (file) {
                this.previewImage = file.url || file.thumbUrl
                this.previewVisible = true
            },
            handleChange ({ fileList }) {
                this.fileList = fileList;
            },
            openDetails() {
                this.showDetails = true
            },
            openHistory() {
                this.showDetails = false
            },
            // Dynamic Form
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bagger
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors
                if(this.customFormMode == 3) {
                    this.errors = errors
                }
                this.bagger = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumeric('Code', this.epay_logo.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.epay_logo.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.epay_logo.name));
                this.errors.push(ValidateField.alphanumericWithSpace('Name', this.epay_logo.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.epay_logo.name, 0, 50));
                this.errors.push(ValidateField.charMinAndMax('Remark', this.epay_logo.remark, 0, 8000));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {

                    let file = null;
                    if(this.fileList.length > 0){
                        if (this.fileList[0].response == undefined){
                            file = this.fileList[0].name
                        } else {
                            file = this.fileList[0].response
                        }
                    }
                    this.epay_logo.filename = file

                    this.epay_logo.name = this.epay_logo.name.trim()
                    if (this.epay_logo.code != undefined)
                        this.epay_logo.code = this.epay_logo.code.trim()
                    this.epay_logo.status = 'A'
                    var epay_logoPayload = { epay_logo: this.epay_logo }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'epay_logos', null, epay_logoPayload)    
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {

                    let file = null;
                    if(this.fileList.length > 0){
                        if (this.fileList[0].response == undefined){
                            file = this.fileList[0].name
                        } else {
                            file = this.fileList[0].response
                        }
                    }
                    this.epay_logo.filename = file

                    this.epay_logo.name = this.epay_logo.name.trim()
                    if (this.epay_logo.code != undefined)
                        this.epay_logo.code = this.epay_logo.code.trim()
                    // this.epay_logo.status = 'A'
                    let status = (this.epay_logo.status == null) ?  "A" : this.epay_logo.status
                    this.epay_logo.status = status

                    var epay_logoPayload = { epay_logo: this.epay_logo }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'epay_logos/' + this.profileId, null, epay_logoPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>